import React, { useState, useEffect, useRef } from 'react'
import './styles.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

import useRequest from 'hooks/useRequest';
import { useQuery } from 'hooks/useQuery';

import Nav from 'react-bootstrap/Nav'

const FiltroFacturacion = ({ filtro, calcular, facturas}) => {

    const {
        submitted, success, message,
        beforeSubmit,
    } = useRequest();

    const query = useQuery();
    const todosClick = useRef(null);
    const ningunoClick = useRef(null);
    
    useEffect(() => {
        // console.log(query.get('seleccionar'));
        if (query.get('seleccionar') === "todos"){
            todosClick.current.click()
        }
        if (query.get('seleccionar') === null) {
            ningunoClick.current.click()
        }
    }, [facturas]);

    const filtrar = (key) => {
        filtro(key);
        calcular(key);
    };

    return <div className="facturacion-filtro">
        <p>SELECCIONAR: </p>
        <Nav justify variant="tabs">
            <Nav.Item>
                <Nav.Link ref={todosClick} eventKey="todos" onClick={() => filtrar("todos")}>Todos</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="vencido" onClick={() => filtrar("vencido")}>Vencido</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey="por-vencer" onClick={() => filtrar("por-vencer")}>Por Vencer</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link ref={ningunoClick} eventKey="ninguno" onClick={() => filtrar("ninguno")}>
                    Ninguno
                </Nav.Link>
            </Nav.Item>
        </Nav>
    </div>
}

export default FiltroFacturacion;